import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { useSelector } from 'react-redux';

const headerStyles = makeStyles({
  customHeader: {
    minHeight: '110px !important',
  },
});

function FusePageCardedHeader(props) {
  const mainThemeDark = useSelector(({ fuse }) => fuse.settings.mainThemeDark);

  const styles = headerStyles();

  return (
    <div className={`${props.classes.header} ${styles.customHeader}`}>
      {props.header && <ThemeProvider theme={mainThemeDark}>{props.header}</ThemeProvider>}
    </div>
  );
}

export default FusePageCardedHeader;
